module.exports = __webpack_public_path__ + "media/images/correct-date-7cfbcced.png";